import { render } from "./payBottomInfo.vue?vue&type=template&id=09e48d30&scoped=true"
import script from "./payBottomInfo.vue?vue&type=script&lang=js"
export * from "./payBottomInfo.vue?vue&type=script&lang=js"

import "./payBottomInfo.vue?vue&type=style&index=0&id=09e48d30&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/workspace/asoworld-uatnf9mf/asoworld-wap-frontend/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09e48d30"]])

export default __exports__